import { Component } from '@angular/core';
import {CardModule} from "primeng/card";
import {FooterGovCoComponent} from "./footer-gov-co/footer-gov-co.component";
import {ScrollTopModule} from "primeng/scrolltop";
import {HeaderGovCoComponent} from "./header-gov-co/header-gov-co.component";
import {CarrouselGovCoComponent} from "./carrousel-gov-co/carrousel-gov-co.component";
import {AccessibilityGovCoComponent} from "./accessibility-gov-co/accessibility-gov-co.component";
import {RouterOutlet} from "@angular/router";
import {
  AuthenticationManagerComponent
} from "../../../components/global/authentication-manager/authentication-manager.component";

@Component({
  selector: 'app-sede-electronica',
  standalone: true,
  imports: [
    CardModule,
    FooterGovCoComponent,
    ScrollTopModule,
    HeaderGovCoComponent,
    AccessibilityGovCoComponent,
    RouterOutlet,
    AuthenticationManagerComponent
  ],
  template: `
    <app-authentication-manager/>
    <div>
      <app-header-gov-co/>
      <main class="principal-section ">
        <router-outlet/>
      </main>
      <app-accessibility-gov-co/>
      <app-footer-gov-co/>

    </div>
    <p-scrollTop/>
  `,
  styleUrl: './sede-electronica.component.scss'
})
export class SedeElectronicaComponent {

}
